

// // src/pages/Staff/StaffForm.jsx
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";

// export default function StaffForm({ user, onDone, onCancel }) {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     password: "",
//     role_id: "",
//   });
//   const [roles, setRoles] = useState([]);
// const [teams, setTeams] = useState([]);
//   useEffect(() => {
//     api.get("/roles").then((res) => setRoles(res.data.roles || [])).catch(() => setRoles([]));
//     api.get("/teams").then((res) => setTeams(res.data.teams || [])).catch(() => setTeams([]));
//     if (user) {
//       setForm({
//         name: user.name || "",
//         email: user.email || "",
//         password: "",
//         role_id: user.role_id || "",
//       });
//     }
//   }, [user]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (user) {
//         await api.put(`/users/${user.id}`, {
//           name: form.name,
//           email: form.email,
//           role_id: form.role_id,
//           team_id: form.team_id || null,
//         });
//       } else {
//         await api.post("/users", form);
//       }
//       onDone();
//     } catch (err) {
//       alert(err?.response?.data?.message || "Save failed");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-8">
//       {/* Full Name */}
//       <div>
//         <label className="block text-sm font-semibold text-gray-700 mb-3">
//           Full Name <span className="text-red-500">*</span>
//         </label>
//         <input
//           type="text"
//           required
//           value={form.name}
//           onChange={(e) => setForm({ ...form, name: e.target.value })}
//           className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition"
//           placeholder="Enter full name"
//         />
//         <p className="text-sm text-gray-500 mt-2">
//           The user's name will be displayed on all pages.
//         </p>
//       </div>

//       {/* Email */}
//       <div>
//         <label className="block text-sm font-semibold text-gray-700 mb-3">
//           Email <span className="text-red-500">*</span>
//         </label>
//         <input
//           type="email"
//           required
//           value={form.email}
//           onChange={(e) => setForm({ ...form, email: e.target.value })}
//           className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition"
//           placeholder="user@example.com"
//         />
//       </div>

//       {/* Password - Only for new user */}
//       {!user && (
//         <div>
//           <label className="block text-sm font-semibold text-gray-700 mb-3">
//             Password <span className="text-red-500">*</span>
//           </label>
//           <div className="relative">
//             <input
//               type="password"
//               required
//               value={form.password}
//               onChange={(e) => setForm({ ...form, password: e.target.value })}
//               className="w-full px-6 py-4 pr-14 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition"
//               placeholder="••••••••"
//             />
//             <div className="absolute inset-y-0 right-0 pr-5 flex items-center pointer-events-none">
//               <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//               </svg>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* User Role */}
//       <div>
//         <label className="block text-sm font-semibold text-gray-700 mb-3">
//           User Role <span className="text-red-500">*</span>
//         </label>
//         <select
//           value={form.role_id}
//           onChange={(e) => setForm({ ...form, role_id: e.target.value })}
//           required
//           className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition bg-white"
//         >
//           <option value="" disabled>
//             Select a User Role
//           </option>
//           {roles.map((role) => (
//             <option key={role.id} value={role.id}>
//               {role.caption || role.name}
//             </option>
//           ))}
//         </select>
//       </div>
     

// <div>
//   <label className="block text-sm font-semibold text-gray-700 mb-3">
//     Team
//   </label>
//   <select
//     value={form.team_id || ""}
//     onChange={(e) => setForm({ ...form, team_id: e.target.value || null })}
//     className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition bg-white"
//   >
//     <option value="">No Team</option>
//     {teams.map((team) => (
//       <option key={team.id} value={team.id}>
//         {team.name}
//       </option>
//     ))}
//   </select>
// </div>

//       {/* Buttons */}
//       <div className="flex justify-end gap-6 pt-8 border-t border-gray-200">
//         <button
//           type="button"
//           onClick={onCancel}
//           className="px-10 py-4 bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold rounded-xl transition"
//         >
//           Cancel
//         </button>
//         <button
//           type="submit"
//           className="px-10 py-4 bg-[#0f172a] hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg transition"
//         >
//           {user ? "Update" : "Create"}
//         </button>
//       </div>
//     </form>
//   );
// }
// src/pages/Staff/StaffForm.jsx
import React, { useEffect, useState } from "react";
import api from "../../utils/api";

export default function StaffForm({ user, onDone, onCancel, mode = "light" }) {
  
  const isDark = mode === "dark";

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role_id: "",
    team_id: "",
  });

  const [roles, setRoles] = useState([]);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    api.get("/roles").then((res) => setRoles(res.data.roles || [])).catch(() => setRoles([]));
    api.get("/teams").then((res) => setTeams(res.data.teams || [])).catch(() => setTeams([]));

    if (user) {
      setForm({
        name: user.name || "",
        email: user.email || "",
        password: "",
        role_id: user.role_id || "",
        team_id: user.team_id || "",
      });
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: form.name,
        email: form.email,
        role_id: form.role_id,
        team_id: form.team_id || null,
      };

      if (user) {
        // Update (don't send password unless changed)
        if (form.password) payload.password = form.password;
        await api.put(`/users/${user.id}`, payload);
      } else {
        // Create (require password)
        if (!form.password) {
          alert("Password is required for new users");
          return;
        }
        await api.post("/users", { ...payload, password: form.password });
      }
      onDone();
    } catch (err) {
      alert(err?.response?.data?.message || "Save failed");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-8">
      {/* Full Name */}
      <div>
        <label className={`block text-sm font-semibold mb-3 ${isDark ? "text-slate-300" : "text-gray-700"}`}>
          Full Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          required
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className={`w-full px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
            isDark
              ? "bg-slate-700 border-slate-600 text-white placeholder-slate-400"
              : "bg-white border-gray-300 text-gray-900 placeholder-gray-400"
          }`}
          placeholder="Enter full name"
        />
        <p className={`text-sm mt-2 ${isDark ? "text-slate-400" : "text-gray-500"}`}>
          The user's name will be displayed on all pages.
        </p>
      </div>

      {/* Email */}
      <div>
        <label className={`block text-sm font-semibold mb-3 ${isDark ? "text-slate-300" : "text-gray-700"}`}>
          Email <span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          required
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className={`w-full px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
            isDark
              ? "bg-slate-700 border-slate-600 text-white placeholder-slate-400"
              : "bg-white border-gray-300 text-gray-900 placeholder-gray-400"
          }`}
          placeholder="user@example.com"
        />
      </div>

      {/* Password - Only for new user */}
      {!user && (
        <div>
          <label className={`block text-sm font-semibold mb-3 ${isDark ? "text-slate-300" : "text-gray-700"}`}>
            Password <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className={`w-full px-6 py-4 pr-14 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
                isDark
                  ? "bg-slate-700 border-slate-600 text-white placeholder-slate-400"
                  : "bg-white border-gray-300 text-gray-900 placeholder-gray-400"
              }`}
              placeholder="••••••••"
            />
            <div className="absolute inset-y-0 right-0 pr-5 flex items-center pointer-events-none">
              <svg className={`w-6 h-6 ${isDark ? "text-slate-400" : "text-gray-400"}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
          </div>
        </div>
      )}

      {/* Role */}
      <div>
        <label className={`block text-sm font-semibold mb-3 ${isDark ? "text-slate-300" : "text-gray-700"}`}>
          User Role <span className="text-red-500">*</span>
        </label>
        <select
          value={form.role_id}
          onChange={(e) => setForm({ ...form, role_id: e.target.value })}
          required
          className={`w-full px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
            isDark
              ? "bg-slate-700 border-slate-600 text-white"
              : "bg-white border-gray-300 text-gray-900"
          }`}
        >
          <option value="" disabled>
            Select a User Role
          </option>
          {roles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.caption || role.name}
            </option>
          ))}
        </select>
      </div>

      {/* Team */}
      <div>
        <label className={`block text-sm font-semibold mb-3 ${isDark ? "text-slate-300" : "text-gray-700"}`}>
          Team
        </label>
        <select
          value={form.team_id || ""}
          onChange={(e) => setForm({ ...form, team_id: e.target.value || null })}
          className={`w-full px-6 py-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 transition ${
            isDark
              ? "bg-slate-700 border-slate-600 text-white"
              : "bg-white border-gray-300 text-gray-900"
          }`}
        >
          <option value="">No Team</option>
          {teams.map((team) => (
            <option key={team.id} value={team.id}>
              {team.name}
            </option>
          ))}
        </select>
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-6 pt-8 border-t border-gray-200 dark:border-slate-700">
        <button
          type="button"
          onClick={onCancel}
          className={`px-10 py-4 font-bold rounded-xl transition ${
            isDark ? "bg-slate-700 hover:bg-slate-600 text-slate-200" : "bg-gray-300 hover:bg-gray-400 text-gray-800"
          }`}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={`px-10 py-4 font-bold rounded-xl shadow-lg transition ${
            isDark ? "bg-slate-800 hover:bg-orange-600 text-white" : "bg-[#0f172a] hover:bg-orange-600 text-white"
          }`}
        >
          {user ? "Update" : "Create"}
        </button>
      </div>
    </form>
  );
}